<!-- 组件模板 -->
<template id="alipay-payment-template">
    <div class="payment-container">
        <!-- 头部信息 -->
        <div class="payment-header">
            <h1>支付宝支付</h1>
            <p>安全 · 便捷 · 快速</p>
        </div>

        <!-- 支付信息卡片 -->
        <div class="payment-card">

            <div class="payment-summary">
                <div class="payment-row">
                    <span class="value">{{ product }}</span>
                </div>
                <div class="payment-row">
                    <span class="label">订单号:</span>
                    <span class="value">{{ orderId }}</span>
                </div>
                <div class="payment-row">
                    <span class="label">支付金额:</span>
                    <span class="value amount">¥{{ amount }}</span>
                </div>
            </div>

            <template v-if="paymentStatus === 'init' || paymentStatus === 'copying'">
                 <!-- 微信环境提示 -->
                <div class="wechat-payment" v-if="isInWechat">
                    <div class="payment-in-wechat">
                        <div class="loading-spinner">
                            <div class="spinner"></div>
                        </div>
                        <h2>微信内无法直接支付</h2>
                        <p><b>请点击右上角“...”</b></p>
                        <p><b>选择“在浏览器打开”以完成支付宝支付</b></p>
                        <p>或者复制支付链接在浏览器中打开完成支付</p>
                    </div>

                    <div class="copy-section">
                        <button class="copy-button" @click="copyPaymentLink" :disabled="isCopied">
                            <span v-if="!isCopied">
                                复制支付链接
                            </span>
                            <span v-else class="copied-text">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" fill="#07C160"></path>
                                </svg>
                                已复制
                            </span>
                        </button>

                        <div v-if="isCopied" class="success-message">
                            链接已复制到剪贴板！请转到浏览器粘贴并打开
                        </div>
                    </div>
                </div>
                <!-- 浏览器环境提示 -->
                <div class="browser-payment" v-else>
                    <div class="payment-status-alipay">
                        <div class="loading-spinner">
                            <div class="spinner"></div>
                        </div>
                        <h2>正在跳转到支付宝支付页面...</h2>
                        <p>请在新页面完成支付操作</p>
                        <p v-if="isLogin === false">如您已完成支付，请回到微信刷新页面</p>
                    </div>
                </div>
            </template>

            <!-- 支付结果检测 -->
            <div class="payment-status-check" v-else-if="paymentStatus === 'polling'">
                <div class="payment-status-alipay">
                    <div class="loading-spinner">
                        <div class="spinner"></div>
                    </div>
                    <h2>支付结果检测中...</h2>
                    <p>已开始检测支付状态</p>
                    <p>支付成功后页面将自动刷新</p>
                    <div class="countdown">{{ pollingCountdown }}</div>
                </div>
            </div>

            <!-- 支付完成状态 -->
            <div class="payment-complete" v-else-if="paymentStatus === 'success'">
                <div class="success-icon">
                    <svg viewBox="0 0 24 24" width="72" height="72">
                        <path
                            d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                            fill="#07C160"></path>
                    </svg>
                </div>
                <h2>支付成功</h2>
                <p>订单已完成支付，感谢您的购买！</p>
                <button class="action-button" @click="goPayStatusPage">{{isFenQi ? '即将返回' : '好的'}}</button>
            </div>

            <!-- 异常状态 -->
            <div class="payment-fail" v-else-if="paymentStatus === 'error'">
                <div class="error-icon">
                    <svg viewBox="0 0 24 24" width="72" height="72" fill="#ff4757">
                        <path
                            d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                    </svg>
                </div>
                <h2>支付异常</h2>
                <p>{{ errorMessage }}</p>
                <button class="action-button" @click="goPayStatusPage">我知道了</button>
            </div>

            <!-- 取消支付 -->
            <template v-if="paymentStatus === 'init'">
                <div style="padding-bottom: 16px;"  v-if="isLogin === false">
                    <button class="action-button" @click="reloadPage" >发起支付</button>
                </div>
                <button class="action-button secondary" @click="goPayStatusPage" >取消支付</button>
            </template>
        </div>

        <!-- 底部信息 -->
        <div class="payment-footer">
            <p>如果您遇到任何问题，请联系官方客服</p>
            <p>支付链接由您从订单发起，勿信他人发的链接，防止诈骗</p>
        </div>
        <!-- 支付宝表单 (隐藏渲染) -->
        <div ref="formContainer" v-html="formContent"></div>

        <browser-mask :visible.sync="showMask" @close="handleMaskClose"/>
    </div>
</template>

<!-- 必须引入微信JS-SDK -->
<script src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>

<script>
import BrowserMask from "@components/BrowserMask";
import { isWeixin, VUE_APP_API_URL } from "@utils";
import { getAlipayPayForm, getOrderPaymentStatus } from "@api/order";

export default {
    name: 'AlipayRedirect',
    components: {
        BrowserMask
    },
    data() {
        return {
            isLogin: false,     //没登录，证明是从微信跳出来的
            checkCount: 100,
            isInWechat: false,
            showMask: false,
            formContent: '',
            pollingTimer: null,
            orderId: '--',
            product: '--',
            amount: '--',
            paymentLink: '',
            pollingCountdown: 3,
            paymentStatus: 'init', // init, copying, polling, success, error
            isCopied: false,
            errorMessage: '',
            isFenQi: false,
            code: ''     //短链接码，也可以以此查订单状态
        };
    },
    mounted() {
        this.isLogin = this.$store.state.app.token ? true : false;
        this.isInWechat = isWeixin();
        this.orderId = this.$route.query.id || '--';
        this.code = this.$route.query.code || '';
        this.paymentLink = this.code ? (VUE_APP_API_URL + '/' + this.code) : '';
        this.isFenQi = (String(this.orderId).indexOf('-') !== -1);

        if (!this.code) {
            this.handleError('未接收到支付表单数据');
            return;
        }
        this.fetchPayForm();
    },
    methods: {
        fetchPayForm() {
            getAlipayPayForm(this.code)
                .then(res => {
                    const formHtml = (res.data && res.data.form) || '';
                    if (!formHtml) {
                        this.handleError('未接收到支付表单数据');
                        return;
                    }
                    if (res.data.order_id) {
                        this.orderId = res.data.order_id;
                        this.isFenQi = (String(this.orderId).indexOf('-') !== -1);
                    }
                    this.initWithForm(formHtml);
                })
                .catch(err => {
                    this.handleError((err && err.msg) || '支付链接已失效，请重新发起支付');
                });
        },

        initWithForm(formHtml) {
            this.formContent = formHtml;
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(formHtml, "text/html");
                const bizContentInput = doc.querySelector('input[name="biz_content"]');
                if (bizContentInput) {
                    const bizContent = JSON.parse(bizContentInput.value);
                    this.product = bizContent.subject;
                    this.amount = bizContent.total_amount;
                }
            } catch (e) {
                console.error('解析支付表单失败:', e);
            }
            this.startPayFlow();
        },

        startPayFlow() {
            if (this.isInWechat) {
                this.showMask = true;
                setTimeout(() => {
                    this.showMask = false;
                    if (this.paymentStatus === 'init') {
                        this.paymentStatus = 'polling';
                        this.startPollingCountdown();
                    }
                }, 10000);
                return;
            }

            this.showMask = false;
            this.$nextTick(() => {
                this.submitAlipayForm();
            });

            if (this.isLogin) {
                setTimeout(() => {
                    this.paymentStatus = 'polling';
                    this.startPollingCountdown();
                }, 10000);
            }
        },

        //唤起支付宝
        submitAlipayForm() {
            try {
                const formElement = this.$refs.formContainer.querySelector('form');
                if (formElement) {
                    formElement.submit();
                } else {
                    this.handleError('无效的支付表单格式');
                }
            } catch (error) {
                this.handleError('支付表单提交失败: ' + error.message);
            }
        },
        //展示异常信息
        handleError(message) {
            this.errorMessage = message;
            this.paymentStatus = 'error';
            console.error('支付宝跳转错误:', message);
        },

        retry() {
            this.errorMessage = '';
            this.$nextTick(this.submitAlipayForm);
        },

        //复制支付链接
        copyPaymentLink() {
            navigator.clipboard.writeText(this.paymentLink)
                .then(() => {
                    this.isCopied = true;
                    this.paymentStatus = 'copying';
                    setTimeout(() => {
                        this.paymentStatus = 'polling';
                        this.startPollingCountdown(); 
                    }, 20000); 
                })
                .catch(err => {
                    console.error('复制失败:', err.msg);
                    this.$dialog.error('复制失败，请手动复制链接');
                });
        },

        //微信环境支付状态轮询倒计时
        startPollingCountdown() {
            this.pollingTimer = setInterval(() => {
                if (this.pollingCountdown != '查询中...') {
                    if (this.pollingCountdown > 0) {
                        this.pollingCountdown--;
                    } else {
                        this.checkPaymentStatus(); // 检查支付状态
                    }
                }
            }, 1000);
        },

        //检查支付状态
        checkPaymentStatus() {
            let that = this;
            this.pollingCountdown = '查询中...';
            this.checkCount --;
            if(this.checkCount < 1) {
                clearInterval(this.pollingTimer);
                this.paymentStatus = 'error';
                this.errorMessage = '结果检测超时，请刷新订单详情';
                return;
            }
            getOrderPaymentStatus(this.code)
                .then(res=>{
                    if(res.msg == '已支付') {
                        clearInterval(this.pollingTimer);
                        that.paymentStatus = 'success';
                        setTimeout(() => {
                            that.goPayStatusPage();
                        }, 1200);
                    }
                    else {
                        that.pollingCountdown = 3;
                    }
                })
                .catch(err=>{
                    clearInterval(this.pollingTimer);
                    that.paymentStatus = 'error';
                    that.errorMessage = err.msg;
                    setTimeout(() => {
                        that.goPayStatusPage();
                    }, 1200);
                });
        },

        goPayStatusPage() {
            this.isCopied = false;
            this.pollingCountdown = 3;
            let msg = '';
            let url = "/order/status/" + this.orderId;
            if(this.paymentStatus === 'init' || this.paymentStatus === 'copying') {
                url += "/2?msg=取消支付";
            }
            else if(this.paymentStatus === 'success') {
                url += "/1?msg=支付宝支付成功";
                msg = '支付成功！';
            }
            else if(this.paymentStatus === 'error'){
                url += ("/0?msg=" + this.errorMessage);
                msg = this.errorMessage;
            }
            else {
                url += "/0?msg=支付状态未知，如已支付请刷新订单";
            }

            if(this.isFenQi) {
                if(msg !== '') {
                    this.$dialog.alert({ mes: msg }, () => { });
                }
                let oid = this.orderId.split('-')[0];
                this.$router.replace({ path: "/order/detail/" + oid });
            } else {
                this.$router.replace({ path: url });
            }
        },

        reloadPage() {
            location.reload();
        },

    },
    beforeDestroy() {
        // 清除定时器
        clearInterval(this.pollingTimer);
    }
};
</script>

<style scoped>
.alipay-redirect {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.payment-container {
    width: 100%;
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.payment-header {
    background: linear-gradient(135deg, #1677ff 0%, #095ad9 100%);
    color: white;
    padding: 25px 20px;
    text-align: center;
}

.payment-header h1 {
    font-size: 24px;
    font-weight: 700;
    margin: 15px 0 5px;
}

.payment-header p {
    font-size: 14px;
    opacity: 0.9;
}

.alipay-logo {
    display: inline-flex;
    background: white;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.payment-card {
    padding: 30px 25px;
    text-align: center;
}

.payment-summary {
    background: #f0f7ff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 30px;
    border: 1px solid #e6f0ff;
}

.payment-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-size: 15px;
}

.payment-row:last-child {
    margin-bottom: 0;
}

.label {
    color: #595959;
    font-weight: 500;
}

.value {
    color: #1d1d1d;
    font-weight: 600;
}

.amount {
    color: #f5222d;
    font-weight: 700;
    font-size: 20px;
}

.browser-payment,
.wechat-payment,
.payment-complete {
    text-align: center;
    margin-bottom: 25px;
}

.payment-status-alipay  {
    margin: 0;
}

.payment-status-alipay h2 {
    font-size: 20px;
    margin-bottom: 10px;
    color: #1d1d1d;
}

.payment-status-alipay p {
    color: #595959;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 5px;
}

.payment-in-wechat {
    margin: 0;
}

.payment-in-wechat h2 {
    font-size: 20px;
    margin-bottom: 10px;
    color: #1d1d1d;
}

.payment-in-wechat p {
    color: #595959;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 5px;
}

.loading-spinner {
    margin: 15px 0;
}

.spinner {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    border: 4px solid rgba(22, 119, 255, 0.2);
    border-top: 4px solid #1677ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.small-spinner {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(22, 119, 255, 0.2);
    border-top: 2px solid #1677ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 8px;
    vertical-align: middle;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.countdown {
    font-weight: 700;
    color: #1677ff;
    text-align: center;
    margin: 20px 0;
}

.copy-section {
    margin-top: 25px;
}

.copy-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #1677ff;
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);
    width: 60%;
    height: 44px;
    line-height: 16px;
}

.copy-button:hover {
    background: #095ad9;
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(22, 119, 255, 0.4);
}

.copy-button:disabled {
    background: #bae0ff;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.copied-text {
    display: flex;
    align-items: center;
}

.success-message {
    margin-top: 15px;
    padding: 12px;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    color: #389e0d;
    font-size: 14px;
    animation: fadeIn 0.5s;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.wechat-icon {
    margin-bottom: 15px;
}

.payment-complete .success-icon {
    margin-bottom: 20px;
}

.payment-complete h2 {
    font-size: 24px;
    color: #389e0d;
    margin-bottom: 10px;
}

.payment-complete p {
    color: #595959;
    font-size: 16px;
    margin-bottom: 25px;
}

.payment-fail .success-icon {
    margin-bottom: 20px;
}

.payment-fail h2 {
    font-size: 24px;
    color: #f5222d;
    margin-bottom: 10px;
}

.payment-fail p {
    color: #595959;
    font-size: 16px;
    margin-bottom: 25px;
}

.action-button {
    display: inline-block;
    padding: 12px 30px;
    background: #1677ff;
    color: white;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    width: 60%;
    height: 44px;
    margin: 5px 0;
    line-height: 16px;
    /* margin: 10px 5px; */
}

.action-button.secondary {
    background: #f0f7ff;
    color: #1677ff;
    border: 1px solid #1677ff;
}

.action-button:hover {
    background: #095ad9;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);
}

.action-button.secondary:hover {
    background: #e6f0ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(22, 119, 255, 0.2);
}

.payment-footer {
    text-align: center;
    padding: 20px;
    color: #8c8c8c;
    font-size: 12px;
    background: #f8f8f8;
    border-top: 1px solid #eee;
}

.payment-footer p {
    margin-bottom: 5px;
}

@media (max-width: 480px) {
    .payment-header {
        padding: 20px 15px;
    }

    .payment-card {
        padding: 20px 15px;
    }

    .countdown {
        font-size: 24px;
    }

    .payment-status-alipay h2 {
        font-size: 18px;
    }
}
</style>